import { BaseZendeskState, BaseZendeskFormState } from './types';

export const BaseZendeskFormInitialState: BaseZendeskState = {
  subject: undefined,
  question: ''
};

export const ZendeskWithProductsInitialState: BaseZendeskFormState = {
  ...BaseZendeskFormInitialState,
  products: []
};
